export const TINYMCE_API_KEY =
  "w1c0hp2ji8ni1hudaqpmpq7wsq14rmf37gav2rdnvr2zqy4t";
